import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../logo.png';

export default function NotFound() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '48px 24px',
        textAlign: 'center',
        background: 'linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%)',
        color: '#0f172a',
        boxSizing: 'border-box'
      }}
    >
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: 'inherit', marginBottom: 40 }}>
        <img src={logo} alt="" width={36} height={36} style={{ borderRadius: 8 }} />
        <span style={{ fontSize: 20, fontWeight: 700, letterSpacing: '-0.02em' }}>BloomNav</span>
      </Link>

      <div style={{ fontSize: 72, fontWeight: 800, lineHeight: 1, letterSpacing: '-0.04em', color: '#0f172a', marginBottom: 12 }}>
        404
      </div>
      <h1 style={{ margin: '0 0 8px', fontSize: 22, fontWeight: 700 }}>Page not found</h1>
      <p style={{ margin: '0 0 28px', maxWidth: 360, fontSize: 15, lineHeight: 1.5, color: '#64748b' }}>
        This page doesn’t exist or the link is no longer valid.
      </p>

      <Link
        to="/"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 18px',
          borderRadius: 8,
          background: '#0f172a',
          color: '#fff',
          fontSize: 14,
          fontWeight: 600,
          textDecoration: 'none'
        }}
      >
        Back to home
      </Link>
    </div>
  );
}
